/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { getSelectedVoiceIndex, getVoiceList } from "selectors/readAloudSelectors";
import { ReadAloudPicker } from "components/readAloud/ReadAloudPicker";
import voicePickerIcon from "dc-icons/viewer2021/SDC_SetReadingLanguage_18_N.svg";
import { trackReadAloudVoiceOptionChange } from "analytics/events";

const mapStoresToProps = stores => {
  const voiceList = getVoiceList(stores),
    selectedVoiceIndex = getSelectedVoiceIndex(stores);
  const voiceOptions = voiceList.map((voice, id) => ({
    id,
    label: voice.name,
    selected: id === selectedVoiceIndex
  }));
  const menuStyle = { width: "248px" };
  return {
    options: voiceOptions,
    menuHeading: "label.readAloudVoiceOptions",
    dropdownClassName: "voicePickerIcon",
    menuStyle,
    selectHandler: value => {
      stores.readAloudStore.setUserSelectedVoiceIndex(value);
      if (value !== selectedVoiceIndex) trackReadAloudVoiceOptionChange();
    },
    tooltip: "tooltip.readAloudVoice",
    arialabel: "arialabel.readAloudVoice",
    icon: voicePickerIcon
  };
};

export const ReadAloudVoicePickerContainer = inject(mapStoresToProps)(ReadAloudPicker);
